import { BASE_ADMIN_API_ROOT_PATH } from '../../shared/api/constants/path.constants';

const ADMIN_INVOICES_API_ROOT = `${BASE_ADMIN_API_ROOT_PATH}/invoices`;

export const ADMIN_INVOICES_API_PATHS = {
  LIST_INVOICES: ADMIN_INVOICES_API_ROOT,
  GET_INVOICE_BY_ID: (id: string) => `${ADMIN_INVOICES_API_ROOT}/${id}`,
  GET_INVOICE_DOWNLOAD_URL: (id: string) => `${ADMIN_INVOICES_API_ROOT}/${id}/download`,
  UPDATE_INVOICE_STATUS: (id: string) => `${ADMIN_INVOICES_API_ROOT}/${id}/status`,
  CREATE_SEGMENT_INVOICE: (segmentId: string) =>
    `${BASE_ADMIN_API_ROOT_PATH}/segments/${segmentId}/invoices`,
  CREATE_ORGANIZATION_INVOICE: (organizationId: string) =>
    `${BASE_ADMIN_API_ROOT_PATH}/organizations/${organizationId}/invoices`,
};
